import { render, staticRenderFns } from "./RoadmapEditor.vue?vue&type=template&id=3d70a032"
import script from "./RoadmapEditor.vue?vue&type=script&lang=js"
export * from "./RoadmapEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports